import React from "react";
import { useParams, Navigate } from "react-router-dom";
import SettingsPage from "@/pages/Settings";
import { ENTREPRISE_TAB_MAP } from "@/lib/constants";

export default function Entreprise() {
  const { tab } = useParams();
  const mapped = ENTREPRISE_TAB_MAP[tab];
  if (!mapped) return <Navigate to="/app/entreprise/organisation" replace />;
  return <SettingsPage initialTab={mapped} showTabList={false} />;
}
